import style from './Button.module.css';

export const Button = ({ children, ...rest }) => <button className={style.button} {...rest}>{children}</button>;